const checkForIeAndDisplayMessage = () => {
    const isIE11 = () => {
        // IE 10 and IE 11
        return /Trident\/|MSIE/.test(window.navigator.userAgent);
    }
    if (document.querySelector('.unsupported-browser')) {
        let d = document.getElementsByClassName('unsupported-browser');

        const is_IE11 = isIE11();

        if (is_IE11) {
            d[0].innerHTML = '<b>Nicht unterstützer Browser!</b> Diese Webseite funktioniert in diesem Browser nur eingeschränkt. Bitte benutzen Sie eine aktuelle Version eines modernen Browsers zur Ansicht dieser Webseite.';
            d[0].style.display = 'block';
            d[0].style.backgroundColor = 'white';
            d[0].style.padding = '16px';
            d[0].style.position = 'absolute';
            d[0].style.left = '25%';
            d[0].style.right = '25%';
            d[0].style.top = '500px';
            d[0].style.zIndex = '9999';
        }
    }
}
export default  checkForIeAndDisplayMessage;